export default __webpack_public_path__ + "alberta-payer.d1b42667d83671144f1a.svg";